<template>
  <el-container id="sceneTiming">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <!--      <el-header style="margin:0;padding:0">-->
      <!--        <el-menu :default-active="paths" class="el-menu-demo" mode="horizontal"-->
      <!--                 background-color="#FFFFFF" active-text-color="#1250B4">-->
      <!--          <el-menu-item index="/home/timing/ble" @click.native.stop="handleSelectMenu('/home/timing/ble')">-->
      <!--            蓝牙定时-->
      <!--          </el-menu-item>-->
      <!--          <el-menu-item index="/home/timing/other" @click.native.stop="handleSelectMenu('/home/timing/other')">-->
      <!--            其他定时-->
      <!--          </el-menu-item>-->
      <!--        </el-menu>-->
      <!--      </el-header>-->
      <el-main style="background:#FFFFFF;padding:15px">
        <div style="display:flex;height:36px;width:100%;line-height:0.3;text-align:left;align-items: center;">
          <span style="margin-left:0;color: #ffffff; font-size: 13px">
            <el-select v-model="edi_pwr" ref='select1'
                       @visible-change='show_change1'
                       clearable filterable placeholder="使能开关"
                       style="width:10vw;">
              <el-option
                v-for="item in li_pwr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                  <!--@click.native="show_table(httpData,roomData)"-->
              </el-option>
            </el-select>
          </span>
          <span style="margin-left:0.5vw;color: #ffffff; font-size: 13px">
            <el-select v-model="edi_zq" ref='select2'
                       @visible-change='show_change2'
                       clearable filterable placeholder="执行周期"
                       style="width:10vw;">
              <el-option
                v-for="item in li_zq"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </span>
          <!--          <span style="margin-left:0.5vw;color: #ffffff; font-size: 13px">
                      <el-select v-model="edi_wx" ref='select3'
                                 @visible-change='show_change3'
                                 clearable filterable placeholder="是否关联微信"
                                 style="width:10vw;">
                        <el-option
                          v-for="item in li_wx"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </span>-->
          <!--      @keyup.enter.native="init_View()"
                    @clear="init_View()"-->
          <span style="margin-left:0.5vw; color: #ffffff; font-size: 13px">
            <el-input
              placeholder="输入定时名称查询"
              style="width:10vw;"
              prefix-icon="el-icon-search"
              clearable
              v-model="scan_name">
            </el-input>
          </span>
          <el-button v-if="!is_ble" @click="addTiming" size="small" type="primary" icon="el-icon-plus"
                     style="margin-left:auto;margin-right:15px">
            新增定时
          </el-button>
        </div>
        <el-table :data=fil_tabData class="tab_adb" :cell-style="tableYs"
                  style="width:100%; font-size:13px; background:#FFFFFF;margin-top:10px"
                  :max-height=maxHeight show-overflow-tooltip
                  :header-cell-style="{'height':'30px','text-align':'center','background':'#F4F4F4','color':'#0dA7C8'}">
          <el-table-column width="01" sortable/>
          <div v-for="(d,item) in this.defHead">
            <el-table-column v-if="d.key!=='使能开关'" :key=item :prop=d.val :label=d.key :width="d.w" sortable>
            </el-table-column>
            <el-table-column v-else label="使能开关" width="200">
              <template v-slot="scope">
                <el-switch
                  v-if="scope.row[d.val]"
                  v-model="scope.row[d.val]"
                  active-text="打开"
                  @change="changeTimer(scope.row)"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                </el-switch>
                <el-switch
                  v-else
                  v-model="scope.row[d.val]"
                  active-text="关闭"
                  @change="changeTimer(scope.row)"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                </el-switch>
              </template>
            </el-table-column>
          </div>
          <el-table-column
            label="操作"
            width="200">
            <template slot-scope="scope">
              <el-button @click="change_dvc(scope.row)" type="text" size="small" icon="el-icon-edit"
                         style="color:#72767b;font-size: 16px"/>
              <el-button @click="del_Timer(scope.row)" type="text" size="small" icon="el-icon-delete"
                         style="color:#72767b;font-size: 16px"/>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="float:right; margin-right:0.5vw;margin-top:5px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange1"
          :current-page="page"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </el-main>
    </el-container>
    <el-dialog
      title="删除提示"
      :visible.sync="daidelTimer"
      width="30%">
      <span>确定删除该定时吗？ 删除后将无法找回，请谨慎操作</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="daidelTimer = false">取 消</el-button>
        <el-button type="primary" @click=delTimer()>确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
export default {
  name:"sceneTiming",
  data(){
    return {
      is_ble:false,
      paths:"/home/timing/ble",
      h_text:"定时策略",
      li_h_text:[
        {"text":"节能策略","colour":"#B7B7B7","pages":""}
      ],
      edi_pwr:[],
      li_pwr:[
        {
          value:'打开',
          label:'打开'
        },
        {
          value:'关闭',
          label:'关闭'
        }
      ], /*角色列表*/
      li_Timer:[],
      scan_name:"",
      page:1,
      pageSize:10,
      total:0,
      maxHeight:window.innerHeight - 225,
      defHead:[
        {'key':"序号",'val':"item","w":"200px"},
        {'key':"定时名称",'val':"name","w":"auto"},
        {'key':"定时时间",'val':"times","w":"auto"},
        {'key':"执行周期",'val':"cycle_show","w":"auto"},
        {'key':"执行场景",'val':"scene_show","w":"auto"},
        {'key':"使能开关",'val':"timeState","w":"auto"}
      ],
      tabData:[],
      edi_zq:"",
      li_zq:[
        {
          value:'周一',
          label:'周一'
        },
        {
          value:'周二',
          label:'周二'
        },
        {
          value:'周三',
          label:'周三'
        },
        {
          value:'周四',
          label:'周四'
        },
        {
          value:'周五',
          label:'周五'
        },
        {
          value:'周六',
          label:'周六'
        },
        {
          value:'周日',
          label:'周日'
        }
      ],
      edi_wx:"",
      li_wx:[
        {
          value:'是',
          label:'是'
        },
        {
          value:'否',
          label:'否'
        }
      ],
      post_head:{},
      daidelTimer:false
    };
  },
  methods:{ /*方法存放*/
    handleSelectMenu(path){ /*左侧导航栏事件*/
      console.log(path);
      this.paths = path;
      this.is_ble = path.includes("ble");
      if(this.is_ble) {
        localStorage.setItem("is_ble_timing","1");
      } else {
        localStorage.setItem("is_ble_timing","0");
      }
      this.getTiming();
    },
    change_dvc(row){
      this.$router.push({ /*路由跳转传值*/
        path:'/home/timingSon',
        query:{
          key:'changeTiming',
          id:row.id,
          name:row.name,
          hour:row.hour,
          minute:row.minute,
          second:row.second,
          cycle:row.cycle,
          scene:row.scene
        }
      });
    },
    addTiming(){
      this.$router.push({ /*路由跳转传值*/
        path:'/home/timingSon',
        query:{key:'addTiming'}
      });
    },
    changeTimer(row){
      const params = {
        'id':row.id,
        'projectId':localStorage.getItem("projectId")
      };
      params['enable'] = row.timeState;
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.enableTimer,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("修改成功");
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("修改失败");
        }
      });
    },
    del_Timer(row){
      this.id = row.id;
      this.daidelTimer = true;
    },
    delTimer(){
      const params = {
        'id':this.id,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.delTimer,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("删除成功");
        this.daidelTimer = false;
        this.getTiming();
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("删除失败");
        }
      });
    },
    tableYs({row,column,rowIndex,columnIndex}){ /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getTiming();
    },
    handleCurrentChange1(val){
      this.page = val;
      this.getTiming();
    },
    show_change1(item){
      if(item) {
        this.$refs.select1.focus();
      } else {
        this.$refs.select1.blur();
      }
    },
    show_change2(item){
      if(item) {
        this.$refs.select2.focus();
      } else {
        this.$refs.select2.blur();
      }
    },
    show_change3(item){
      if(item) {
        this.$refs.select3.focus();
      } else {
        this.$refs.select3.blur();
      }
    },
    get_zq(zq){
      const paddingLength = 7 - zq.length;
      for(let i = 0; i < paddingLength; i++) {
        zq = '0' + zq;
      }
      let zqs = "";
      if(zq[5].includes("1")) {
        zqs += "周一、";
      }
      if(zq[4].includes("1")) {
        zqs += "周二、";
      }
      if(zq[3].includes("1")) {
        zqs += "周三、";
      }
      if(zq[2].includes("1")) {
        zqs += "周四、";
      }
      if(zq[1].includes("1")) {
        zqs += "周五、";
      }
      if(zq[0].includes("1")) {
        zqs += "周六、";
      }
      if(zq[6].includes("1")) {
        zqs += "周日、";
      }
      return zqs.slice(0,-1);
    },
    pad(num){
      return num.toString().padStart(2,'0');
    },
    get_cj(cj){
      let c = "";
      for(let i = 0; i < cj.length; i++) {
        c += cj[i]["name"] + "、";
      }
      return c.slice(0,-1);
    },
    init_View(){
      let data = this.li_Timer;
      let li_d = [];
      let j = 1;
      for(let i = 0; i < data.length; i++) {
        let d = {
          item:j,
          id:data[i]['id'],
          name:data[i]['name'],
          hour:data[i]['hour'],
          minute:data[i]['minute'],
          second:data[i]['second'],
          times:this.pad(data[i]['hour']) + ":" + this.pad(data[i]['minute']) + ":" + this.pad(data[i]['second']), /*时间*/
          cycle:data[i]['cycle'],
          timeState:data[i]['enable'],
          scene:data[i]['scene']
        };
        d["cycle_show"] = this.get_zq(d["cycle"].toString(2));
        d["scene_show"] = this.get_cj(d["scene"]);
        if(d.timeState) {
          d['pwr'] = "打开";
        } else {
          d['pwr'] = "关闭";
        }
        /*const aliceItems = this.li_pwr.find((fruit) => { /!*js快速查找数组--筛选当前tree列表*!/
         return fruit['value'] === d.authorityId;
         })
         if (aliceItems !== undefined) {
         d["authName"] = aliceItems["label"];
         }*/
        li_d.push(d);
        j += 1;
      }
      this.tabData = li_d;
    },
    getTiming(){
      const params = {
        'page':this.page,
        'pageSize':this.pageSize,
        'isBle':this.is_ble,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getTimerList,params,headers).then(res => {
        console.log(res.data.data);
        this.li_Timer = res.data.data["list"];
        this.total = res.data.data.total;
        this.init_View();
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("获取场景信息失败");
        }
      });
    }
  },
  mounted(){ /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip");
    // if (localStorage.getItem("isBle") === "1") {
    //   this.is_ble = true;
    // } else {
    //   this.is_ble = false;
    // }
    // if (this.is_ble) {
    //   this.paths = "/home/timing/ble";
    // } else {
    //   this.paths = "/home/timing/other";
    // }
    this.getTiming();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData(){
      return this.tabData.filter(item => {
        this.state = true;
        if(this.edi_pwr && item.pwr !== this.edi_pwr) {
          this.state = false;
        }
        if(this.edi_zq && !item.cycle_show.includes(this.edi_zq)) {
          this.state = false;
        }
        if(this.scan_name && !item.name.includes(this.scan_name)) {
          this.state = false;
        }
        return this.state;
      });
    }
  },
  watch:{  /*监听参数变化*/

  },
  beforeDestroy(){ /*页面结束时调用*/

  }
};
</script>

<style>
#sceneTiming {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #FFFFFF;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}

/*.el-switch .el-switch__label--left {
  color: #FFFFFF; !* 设置左侧标签背景色 *!
}

.el-switch .el-switch__label--right {
  color: #72767b; !* 设置右侧标签背景色 *!
}*/

::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
}

::-webkit-scrollbar-thumb {
  border-radius: 10px; /* 滚动条圆角 */
  background-color: #0dA7C8; /* 滚动条颜色 */
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #cacaca;
  border: 1px solid #cacaca;
}

</style>



// WEBPACK FOOTER //
// src/pages/scene/timing.vue